<script setup>
</script>

<template>
  <td class="border-x-2 text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
    <slot />
  </td>
</template>
